import { MenuIdHome } from '@jira/navigation-apps__constants/src/MenuIdHome.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { resources as alertListResources } from '@atlassian/eoc-alert-list/resources';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { eocChangeboardingLayout } from '@jira/platform__layouts-eoc-changeboarding-layout/src/index.tsx';
import { LazyGlobalAlertsSidebar } from '@jira/navigation-apps__sidebar-eoc-global-alerts/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { eocGlobalAlertListRedirectRoute } from '@jira/router-routes__eoc-global-alerts-routes/src/eocGlobalAlertListRedirectRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { AlertListComponent, LazyAlertList } from './ui/AlertListComponent.tsx';

export const eocGlobalAlertListRedirectRouteEntry: Route = createEntry(
	eocGlobalAlertListRedirectRoute,

	() => ({
		group: 'eoc',
		// eslint-disable-next-line no-restricted-syntax
		component: AlertListComponent,
		layout: eocChangeboardingLayout,

		resources: [
			...getNavigationResources(),
			...alertListResources(),
			getConsolidationStateResource(),
		],

		navigation: {
			menuId: MenuIdHome,
		},

		forPaint: [LazyAtlassianNavigation, LazyAlertList, LazyGlobalAlertsSidebar],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
